module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/labeled-buttons/labeled-buttons.component.scss
// module id = ./src/app/features/buttons/labeled-buttons/labeled-buttons.component.scss
// module chunks = main